<template>
  <router-view name="toptitle" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "TopTitle",
};
</script>
